import { getNamedType, GraphQLList } from 'graphql';
import DataLoader from 'dataloader';
import { delegateToSchema } from '@graphql-tools/delegate';
import { relocatedError } from '@graphql-tools/utils';
const cache1 = new WeakMap();
function createBatchFn(options) {
    var _a;
    const argsFromKeys = (_a = options.argsFromKeys) !== null && _a !== void 0 ? _a : ((keys) => ({ ids: keys }));
    const { valuesFromResults, lazyOptionsFn } = options;
    return async (keys) => {
        const results = await delegateToSchema({
            returnType: new GraphQLList(getNamedType(options.info.returnType)),
            onLocatedError: originalError => relocatedError(originalError, originalError.path.slice(0, 0).concat(originalError.path.slice(2))),
            args: argsFromKeys(keys),
            ...(lazyOptionsFn == null ? options : lazyOptionsFn(options)),
        });
        if (results instanceof Error) {
            return keys.map(() => results);
        }
        const values = valuesFromResults == null ? results : valuesFromResults(results, keys);
        return Array.isArray(values) ? values : keys.map(() => values);
    };
}
export function getLoader(options) {
    var _a;
    const fieldName = (_a = options.fieldName) !== null && _a !== void 0 ? _a : options.info.fieldName;
    let cache2 = cache1.get(options.info.fieldNodes);
    if (cache2 === undefined) {
        cache2 = new WeakMap();
        cache1.set(options.info.fieldNodes, cache2);
        const loaders = Object.create(null);
        cache2.set(options.schema, loaders);
        const batchFn = createBatchFn(options);
        const loader = new DataLoader(keys => batchFn(keys), options.dataLoaderOptions);
        loaders[fieldName] = loader;
        return loader;
    }
    let loaders = cache2.get(options.schema);
    if (loaders === undefined) {
        loaders = Object.create(null);
        cache2.set(options.schema, loaders);
        const batchFn = createBatchFn(options);
        const loader = new DataLoader(keys => batchFn(keys), options.dataLoaderOptions);
        loaders[fieldName] = loader;
        return loader;
    }
    let loader = loaders[fieldName];
    if (loader === undefined) {
        const batchFn = createBatchFn(options);
        loader = new DataLoader(keys => batchFn(keys), options.dataLoaderOptions);
        loaders[fieldName] = loader;
    }
    return loader;
}
//# sourceMappingURL=getLoader.js.map